import { createFileRoute } from '@tanstack/react-router';
import OrdinaryGraphOnline from '../../../components/Graphs/OrdinaryGraph';
import { RPM } from '../../../components/OnlinePanel/Widgets/constants';

export const Route = createFileRoute('/_authenticated/graphs/rpm/$vehicleId')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'infoWindow.data.engineRpm',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RpmGraphRoute,
});

function RpmGraphRoute() {
  const { vehicleId } = Route.useParams();

  return <OrdinaryGraphOnline vehicleId={Number(vehicleId)} name={RPM} isPage />;
}
